import { render, staticRenderFns } from "./xltpList.vue?vue&type=template&id=00f1d84a&scoped=true&"
import script from "./xltpList.vue?vue&type=script&lang=js&"
export * from "./xltpList.vue?vue&type=script&lang=js&"
import style0 from "./xltpList.vue?vue&type=style&index=0&id=00f1d84a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f1d84a",
  null
  
)

export default component.exports